module.exports = __webpack_public_path__ + "img/upload-active.cc93ea1.webp";